import { generateDurationOptions } from "@gymflow/helpers";

export const INTERVAL_ALIGNMENT_VALUES = [
  5, 10, 15, 20, 30, 45, 60, 90, 120, 180, 240,
];

export const selectOptions = generateDurationOptions({
  intervalsInMinutes: 5,
  hours: 4,
});

export const selectOptionsBlockExtraTime = [
  { id: "0", label: "0 Minutes", value: 0 },
  ...selectOptions,
];
